import { Hint, Label, Select } from '@lokalise/louis';

import type { Options } from './types';

export type { Options };

interface FilterRepositoriesInputProps {
    value: Options;
    options: Options;
    onChange: (value: Options) => void;
}

const FilterRepositoriesInput = ({ options, value, onChange }: FilterRepositoriesInputProps) => (
    <Label
        id="FilterRepositoriesInput"
        text={
            <>
                Filter repositories{' '}
                <Hint placement="top">
                    Pull requests will be created only for listed repositories. Leave empty to process all configured
                    integrations by platform only.
                </Hint>
            </>
        }
    >
        <Select aria-labelledby="FilterRepositoriesInput" isMulti options={options} value={value} onChange={onChange} />
    </Label>
);

export default FilterRepositoriesInput;
